var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 34,
    viewBox: "0 0 82 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#528AEA",
    d: "M7 0h68v34H7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#686767",
    d: "M75 17l7 4.25V34h-7zM0 21.25L7 17v17H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.356 9.903H11v-3.37h16.404v3.37h-6.357v17.565h-3.69V9.903zM30.5 6.533h5.624l5.536 14.666 5.595-14.667h5.565v20.936h-3.515V10.08h-.058l-6.298 17.387H40.37L34.072 10.08h-.058v17.387h-3.515V6.532zm37.689 4.494a3.41 3.41 0 0 0-1.567-1.257 5.428 5.428 0 0 0-2.065-.399c-.43 0-.845.05-1.245.148-.4.098-.762.256-1.084.473a2.462 2.462 0 0 0-.776.843c-.196.345-.293.754-.293 1.227 0 .71.244 1.252.732 1.626.488.375 1.094.7 1.816.976.723.276 1.514.542 2.373.798.86.257 1.65.611 2.373 1.065a5.894 5.894 0 0 1 1.816 1.804c.488.749.732 1.744.732 2.986 0 1.124-.205 2.105-.615 2.942a5.985 5.985 0 0 1-1.655 2.085 7.131 7.131 0 0 1-2.417 1.242c-.918.276-1.884.414-2.9.414a10.79 10.79 0 0 1-3.72-.65c-1.191-.434-2.216-1.164-3.075-2.189l2.782-2.72a4.67 4.67 0 0 0 1.772 1.611 4.94 4.94 0 0 0 2.33.577c.429 0 .858-.06 1.288-.177.43-.119.82-.296 1.172-.533.351-.236.634-.537.85-.902a2.43 2.43 0 0 0 .321-1.256c0-.77-.244-1.36-.732-1.774-.488-.414-1.093-.764-1.816-1.05a28.983 28.983 0 0 0-2.373-.813 9.944 9.944 0 0 1-2.372-1.05 5.795 5.795 0 0 1-1.816-1.774c-.489-.74-.733-1.73-.733-2.972 0-1.084.22-2.02.66-2.81a6.067 6.067 0 0 1 1.728-1.966 7.513 7.513 0 0 1 2.445-1.168 10.408 10.408 0 0 1 5.99.119 7.353 7.353 0 0 1 2.769 1.656l-2.695 2.868z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/group-2.d9ecf3763e3b7de80a4bc1a4d75716c2.svg";
export { ForwardRef as ReactComponent };